module.exports = __webpack_public_path__ + "static/media/login-bg.6900f5a9.svg";